module.exports = __webpack_public_path__ + "img/EntityVariable.d85ca8ed.svg";